import { injectable, interfaces } from 'inversify';
import { makeObservable, observable } from 'mobx';
import { IPagingInfoWithOrder, PaginationInfoDefault } from '../../__legacy__/models/paginationInfo.model';
import { ICostUsageDto } from './services/cloudCostsApi.service';

const defaultHistoryDataPaging: IPagingInfoWithOrder = {
  ...PaginationInfoDefault,
  orderBy: 'dateCreated',
  orderType: 'desc',
};

export type IHistoryData = {
  id: string;
  costCalculated: number;
  dateCreated: string;
  jobType: 'Training' | 'Evaluation' | 'AutoTraining';
  jobName: string;
  isDeleted: boolean;
};

export type IPointData = {
  x: number;
  y: number;
};

export type IChartData = Record<string, IPointData[]>;

const CLOUD_COSTS_STORE_INITIAL_STATE: Omit<ICloudCostsStore, 'resetStore'> = {
  costsUsage: null,
  historyData: [],
  historyDataPaging: defaultHistoryDataPaging,
  chartData: {},
  userId: null,
  usersList: [],
};

type UserOption = {
  label: string;
  value: string;
};

export interface ICloudCostsStore {
  costsUsage: ICostUsageDto | null;
  historyData: IHistoryData[];
  historyDataPaging: IPagingInfoWithOrder;
  chartData: IChartData;
  userId: string | null;
  usersList: UserOption[];
  resetStore(): void;
}

export namespace ICloudCostsStore {
  export const $: interfaces.ServiceIdentifier<ICloudCostsStore> = Symbol('CLOUD_COSTS_STORE');
}

@injectable()
export class CloudCostsStore implements ICloudCostsStore {
  costsUsage: ICostUsageDto | null;
  historyData: IHistoryData[];
  historyDataPaging: IPagingInfoWithOrder;
  chartData: IChartData;
  userId: string | null;
  usersList: UserOption[];

  constructor() {
    makeObservable(this, {
      costsUsage: observable,
      historyData: observable,
      historyDataPaging: observable,
      chartData: observable,
      userId: observable,
      usersList: observable,
    });

    this.costsUsage = CLOUD_COSTS_STORE_INITIAL_STATE.costsUsage;
    this.historyData = CLOUD_COSTS_STORE_INITIAL_STATE.historyData;
    this.historyDataPaging = CLOUD_COSTS_STORE_INITIAL_STATE.historyDataPaging;
    this.chartData = CLOUD_COSTS_STORE_INITIAL_STATE.chartData;
    this.usersList = CLOUD_COSTS_STORE_INITIAL_STATE.usersList;
    this.userId = CLOUD_COSTS_STORE_INITIAL_STATE.userId;
  }

  resetStore(): void {
    Object.assign<ICloudCostsStore, Omit<ICloudCostsStore, 'resetStore'>>(this, CLOUD_COSTS_STORE_INITIAL_STATE);
  }
}
